import colors, { BACKGROUND_COLOR } from '@/theme/colors';

function buildTuple<
  T1 extends string,
  T2 extends string,
  T3 extends string,
  T4 extends string,
  T5 extends string,
  T6 extends string,
  T7 extends string,
  T8 extends string,
  T9 extends string
>(p: {
  1: T1;
  2: T2;
  3: T3;
  4: T4;
  5: T5;
  6: T6;
  7: T7;
  8: T8;
  9: T9;
}): readonly [T1, T1, T2, T3, T4, T5, T6, T7, T8, T9];

function buildTuple<
  T1 extends string,
  T2 extends string,
  T3 extends string,
  T4 extends string,
  T5 extends string,
  T6 extends string,
  T7 extends string,
  T8 extends string
>(p: { 1: T1; 2: T2; 3: T3; 4: T4; 5: T5; 6: T6; 7: T7; 8: T8 }): readonly [T1, T1, T2, T3, T4, T5, T6, T7, T8, T8];

function buildTuple(p: Record<number, string>) {
  const ninth = p[9] ?? p[8];
  return [p[1], p[1], p[2], p[3], p[4], p[5], p[6], p[7], p[8], ninth] as const;
}

// Mantine theme 전달용 10-tuple (MantineColorsTuple 호환). `colors: mantineThemeColors`로만 사용.
export const mantineThemeColors = {
  gray: buildTuple(colors.gray),
  red: buildTuple(colors.red),
  yellow: buildTuple(colors.yellow),
  green: buildTuple(colors.green),
  cyan: buildTuple(colors.cyan),
  blue: buildTuple(colors.blue),
  magenta: buildTuple(colors.magenta),
  navy: buildTuple(colors.navy),
  purple: buildTuple(colors.purple),
};

// 애플리케이션 노출용 1-based object index. 팔레트 바깥 인덱스(gray[0], gray[9], red[0], red[10] 등) 접근 시 타입상 실패.
export const mantineColors = {
  ...colors,
  background: BACKGROUND_COLOR,
} as const;

export type MantineColors = typeof mantineColors;
